// src/components/icon/icons.types.ts
var iconColorTypes = ["primary", "secondary", "tertiary", "neutral", "success", "warning", "danger", "white", "black"];
var iconSizes = ["x-small", "small", "medium", "large", "x-large", "xx-large", "xxx-large", "xxxx-large"];

export {
  iconColorTypes,
  iconSizes
};
